import React from 'react';
import PropTypes from 'prop-types';

import MegaHitCard from 'Components/Cards/MegaHitCard';

export default function ProductCard({ body }) {
  if (body.hit) {
    return <MegaHitCard lightTheme hit={body.hit} />;
  }
  return false;
}

ProductCard.propTypes = {
  body: PropTypes.shape({
    slice_type: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    primary: PropTypes.shape({}),
    hit: PropTypes.shape({}),
  }).isRequired,
};
